"use client";
import React from "react";

export function WhyTrustUs() {
  return (
    <section className="w-full px-0 pt-10 md:pt-16 pb-4 md:pb-6">
      <div className="space-y-4 px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-script text-foreground">
          Is this vibe coded slop?
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto font-polysans text-xl md:text-2xl">
          Our past paper and mock questions are pulled from human authored PDFs and original questions are critically reviewed before release - so you can use our question bank with full confidence.
        </p>
      </div>
    </section>
  );
}
